export function InfoIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <title>Info</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.67 10C1.67 5.4 5.4 1.67 10 1.67C14.6 1.67 18.33 5.4 18.33 10C18.33 14.6 14.6 18.33 10 18.33C5.4 18.33 1.67 14.6 1.67 10Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 5.83C9.54 5.83 9.17 6.21 9.17 6.67C9.17 7.13 9.54 7.5 10 7.5L10 7.5C10.46 7.5 10.83 7.13 10.83 6.67C10.83 6.21 10.46 5.83 10 5.83L10 5.83ZM10.825 10C10.825 9.54 10.45 9.17 10 9.17C9.54 9.17 9.17 9.54 9.17 10L9.17 13.33C9.17 13.79 9.54 14.17 10 14.17C10.45 14.17 10.825 13.79 10.825 13.33L10.825 10Z"
        fill="white"
      />
    </svg>
  );
}
